module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAYCAYAAADOMhxqAAAABGdBTUEAALGPC/xhBQAAAHxJREFUOBGVzMsNgCAQRVGQNqQNw9LOtDSL0TbEDImEz3zfYlb3jHOGbSmdXttDnN98qMAfw3MRtLEIxpgFWEwCKkYBF09AijugiSvQxgVYYgALHMvCc9/XGqN32e0aGCCyoAIsqAIt6oAGTUBCKOAQCSjEAgyJYEQq0KIP08pqIj+KENkAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/img_triangle_dark.png
// module id = 249
// module chunks = 1